import {OverlayConfig} from '@/views/Map/MapView';

export const APP_NAME = 'reto-demografico';

export const API_URL = window.APP_CONFIG?.API_BASE_URL;

//backgroundColor-fontColor-variant
export const PROJECT_STAGE_CHIP_CONFIGURATION: Record<string, [string, string, 'filled' | 'outlined']> = {
  INITIAL: ['#ffffff', '#2f2f2f', 'outlined'],
  STUDY: ['#36B9CC', '#ffffff', 'filled'],
  DECREE: ['#848484', '#ffffff', 'filled'],
  PROVISIONAL: ['#FF9D00', '#2f2f2f', 'filled'],
  DEFINITIVE: ['#1CC88A', '#2f2f2f', 'filled'],
};

export const DISPUTE_STATUS_CHIP_CONFIGURATION = {
  PENDING:    ['#FF9D00', '#FFffff'],
  IN_REVIEW:  ['#36B9CC', '#FFFFFF'],
  RESOLVED:   ['#1CC88A', '#FFFFFF'],
  REJECTED:   ['#E74A3B', '#FFFFFF']
};

export const HORIZONTAL_DISPLACEMENT_PANEL = 70;

export const PANEL_WIDTH = {
  profile: 300,
  parcel: 350,
  dispute: 350,
  settings: 550,
  about: 370,
  zoneData: 380,
  documentList: 350,
  addDocument: 300
};

export const INITIAL_VIEWPORT = {
  latitude: 43.42,
  longitude: -5.93,
  zoom: 10,
  bearing: 0,
  pitch: 0
};

export const MAPSTYLES = [
  {
    label: 'PNOA',
    thumbnail: '/assets/mapStyles/pnoa.png',
    id: '/assets/mapStyles/pnoa.json'
  },
  {
    label: 'Basic',
    thumbnail: 'https://tileserver.geomatico.es/styles/klokantech-basic/12/2145/1434.png',
    id: 'https://tileserver.geomatico.es/styles/klokantech-basic/style.json'
  },
  {
    label: 'OSM Bright',
    thumbnail: 'https://tileserver.geomatico.es/styles/osm-bright/12/2145/1434.png',
    id: 'https://tileserver.geomatico.es/styles/osm-bright/style.json'
  },
  {
    label: 'Positron',
    thumbnail: 'https://tileserver.geomatico.es/styles/positron/12/2072/1529.png',
    id: 'https://tileserver.geomatico.es/styles/positron/style.json'
  }
];

export const INITIAL_MAPSTYLE_URL = MAPSTYLES[0].id;

export const PRINCIPADO_OVERLAYS_ID = {
  CATASTRO: 'catastro',
  HIC: 'habitatsInteresComunitario',
  HYDROGRAPHY: 'hidrografía',
  TRANSPORT_NETWORKS: 'redesTransporte',
  CULTURAL_HERITAGE: 'patrimonioCultural',
  BUILDINGS: 'edificaciones'
};

export const CATASTRO_OVERLAY_ID = {
  CATASTRO: 'catastro',
};

export const CETEMAS_OVERLAYS_ID = {
  PARCELAS: 'parcels',
  NUCLEOS_POBLACION: 'nucleosPoblación',
  RED_PISTAS: 'redPistas',
  CLASES_AGROECOLOGICAS: 'clasesAgroecológicas',
  MDT: 'MDT',
  PRENDIENTE: 'pendiente',
  ORIENTACION: 'orientacion',
  COBERTURA_BYN: 'coberturaByn',
  COBERTURA_PNOA: 'coberturaPnoa',
  PRESENCIA_CAMBIO: 'presenciaCambio',
  MONTES_MANO_COMUN: 'montesManoComun',
  MONTES_COVENIO: 'montesConvenio',
  MONTES_UP: 'montesUp',
  TIPO_CAMBIO: 'tipoCambio',
  MDC: 'MDC',
  FCC: 'FCC',
  NUMERO_ESTRATOS: 'numeroEstratos',
  CONTINUIDAD_VERTICAL: 'continuidadVertical',
  INDICIO_FALTA_GESTION: 'indicioFaltaGestion',
  ELEMENTOS_VERTICALES: 'elementosVerticales'
};


export const PRINCIPADO_LAYERS = {
  [PRINCIPADO_OVERLAYS_ID.HIC]: [
    {id: 'Eleocharis_parvula46297', legendsWidth: [20]},
    {id: 'Spartina_maritima50745', legendsWidth: [20]},
    {id: 'Ruppia_maritima34732', legendsWidth: [20]},
    {id: 'Nanozostera_noltei47026', legendsWidth: [20]},
    {id: 'Zostera_marina5145', legendsWidth: [20]},
    {id: 'Reservas_de_la_Biosfera47785', legendsWidth: [220]},
    {id: 'Humedales_Ramsar65393', legendsWidth: [180]},
    {id: 'ZEC', legendsWidth: [300]},
    {id: 'ZEPA', legendsWidth: [300]},
    {id: 'LIC', legendsWidth: [300]},
    {id: 'Hábitats_de_Interés_Comunitario_1:50.0007872', legendsWidth: [20]},
    {id: 'Hábitats_de_Interés_Comunitario_1:10.00021316', legendsWidth: [20]},
    {id: 'Hábitats_de_Interés_Comunitario_1:5.00049536', legendsWidth: [20]},
    {id: 'Paisajes_Protegidos15657', legendsWidth: [300]},
    {id: 'Monumentos_Naturales_-_Polígonos58284', legendsWidth: [300]},
    {id: 'Monumentos_Naturales_-_Puntos11563', legendsWidth: [300]},
    {id: 'Reservas_Naturales9269', legendsWidth: [300]},
    {id: 'Parques_Naturales18451', legendsWidth: [300]},
    {id: 'Parque_Nacional15294', legendsWidth: [200]}
  ],
  [PRINCIPADO_OVERLAYS_ID.HYDROGRAPHY]: [
    /*'Cuencas_Hidrograficas45595',*/
    {id: 'Red_fluvial37347', legendsWidth: [20]},
    {id: 'Rellenos_Hidrografía7571', legendsWidth: [20]},
    {id: 'Lagos_y_Lagunas47929', legendsWidth: [20]},
    {id: 'Embalses', legendsWidth: [20]},
    {id: 'Construcciones_hidrográficas21099', legendsWidth: [20]}
  ],
  [PRINCIPADO_OVERLAYS_ID.TRANSPORT_NETWORKS]: [
    {id: 'Carriles_bici10837', legendsWidth: [40]},
    {id: 'Red_ferroviaria63246', legendsWidth: [40]},
    {id: 'Transporte_suspendido_por_cable32519', legendsWidth: [40]},
    {id: 'Sendas', legendsWidth: [80]},
    {id: 'Caminos', legendsWidth: [80]},
    {id: 'Vías_urbanas26084', legendsWidth: [150]},
    {id: 'Carreteras_-_Polígonos39586', legendsWidth: [200]},
    {id: 'Carreteras_Municipales28677', legendsWidth: [40]},
    {id: 'Carreteras_Locales_de_2_Orden4889', legendsWidth: [40]},
    {id: 'Carreteras_Locales_de_1_Orden21570', legendsWidth: [40]},
    {id: 'Carreteras_Comarcales48945', legendsWidth: [40]},
    {id: 'Carreteras_Regionales45728', legendsWidth: [40]},
    {id: 'Carreteras_Nacionales21708', legendsWidth: [40]},
    {id: 'Autopistas_-_Autovías18093', legendsWidth: [200]}
  ],
  [PRINCIPADO_OVERLAYS_ID.CULTURAL_HERITAGE]: [
    {id: 'Área_de_localización59835', legendsWidth: [20]},
    {id: 'Identificadores_-_BM47950', legendsWidth: [30]},
    {id: 'Vía_Histórica50147', legendsWidth: [30]},
    {id: 'Identificadores_-_V41703', legendsWidth: [30]},
    {id: 'Zona_de_Protección_-_YA20891', legendsWidth: [20]},
    {id: 'Área_Yacimiento_-_polígonos1917', legendsWidth: [20]},
    {id: 'Área_Yacimiento_-_puntos8418', legendsWidth: [20]},
    {id: 'Red_Hidráulica_Minería46539', legendsWidth: [20]},
    {id: 'Caminería', legendsWidth: [20]},
    {id: 'Identificadores_-_YA36073', legendsWidth: [30]},
    {id: 'Zona_de_Protección_-_SC33619', legendsWidth: [20]},
    {id: 'Área_Sitio19154', legendsWidth: [20]},
    {id: 'Identificadores_-_SC9281', legendsWidth: [30]},
    {id: 'Área_Jardín26252', legendsWidth: [20]},
    {id: 'Área_Conjunto36130', legendsWidth: [20]},
    {id: 'Identificadores_-_CA45987', legendsWidth: [30]},
    {id: 'Parcela_Vinculada28274', legendsWidth: [20]},
    {id: 'Construcción_inventariada_-_polígonos60786', legendsWidth: [20]},
    {id: 'Construcción_inventariada_-_puntos56485', legendsWidth: [20]},
    {id: 'Identificadores_-_EI32509', legendsWidth: [30]}
  ],
  [PRINCIPADO_OVERLAYS_ID.BUILDINGS]: [
    {id: 'Cercados', legendsWidth: [20]},
    {id: 'Puentes_-_superficial12917', legendsWidth: [20]},
    {id: 'Puentes_-_lineal20327', legendsWidth: [20]},
    {id: 'Pasarelas', legendsWidth: [20]},
    {id: 'Presas_-_superficial54727', legendsWidth: [20]},
    {id: 'Presas_-_lineal40069', legendsWidth: [20]},
    {id: 'Pistas_deportivas39116', legendsWidth: [200]},
    {id: 'Líneas_esquema_de_pistas_deportivas43014', legendsWidth: [20]},
    {id: 'Pistas_de_aeródromo28206', legendsWidth: [120]},
    {id: 'Pistas_de_Helipuerto20089', legendsWidth: [20]},
    {id: 'Muelles_-_espigones_-_superficial64632', legendsWidth: [120]},
    {id: 'Muelles_-_espigones_-_lineal47282', legendsWidth: [120]},
    {id: 'Obras_de_contención29803', legendsWidth: [20]},
    {id: 'Explanadas', legendsWidth: [120]},
    {id: 'Murallas_-_superficial54592', legendsWidth: [20]},
    {id: 'Murallas_-_lineal27018', legendsWidth: [20]},
    {id: 'Elementos_construidos_-_superficial65408', legendsWidth: [120]},
    {id: 'Elementos_construidos_-_lineal28746', legendsWidth: [120]},
    {id: 'Edificaciones_ligeras29090', legendsWidth: [100]},
    {id: 'Depósitos', legendsWidth: [150]}
  ]
};

export const PRINCIPADO_OVERLAYS: Array<OverlayConfig> = [
  {
    id: PRINCIPADO_OVERLAYS_ID.HIC,
    label: 'Espacios Naturales Protegidos y Hábitats de Interés Comunitario 1:5000',
    url: 'https://sig.asturias.es/servicios/services/EspaciosProtegidos/MapServer/WMSServer?' +
      'service=WMS&' +
      'request=GetMap&' +
      `layers=${PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.HIC].map(layer => layer.id).join(',')}&`+
      'crs=EPSG:3857&' +
      `styles=${PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.HIC].map(() => 'default').join(',')}&`+
      'version=1.3.0&',
    thumbnail: '/assets/overlays/habitatsInteresComunitario.png',
    legendsUrl: PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.HIC].map(layer =>
      `https://sig.asturias.es/servicios/services/EspaciosProtegidos/MapServer/WMSServer?request=GetLegendGraphic%26version=1.3.0%26format=image/png%26layer=${layer.id}`),
    legendsWidth: PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.HIC].flatMap(layer => layer.legendsWidth),
    sublayers: PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.HIC].map(layer => layer.id)
  },
  {
    id: PRINCIPADO_OVERLAYS_ID.HYDROGRAPHY,
    label: 'Hidrografía',
    url: ' https://sig.asturias.es/servicios/services/Hidrografia/MapServer/WMSServer?' +
      'service=WMS&' +
      'request=GetMap&' +
      `layers=${PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.HYDROGRAPHY].map(layer => layer.id).join(',')}&`+
      'crs=EPSG:3857&' +
      `styles=${PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.HYDROGRAPHY].map(() => 'default').join(',')}&`+
      'version=1.3.0&',
    thumbnail:'/assets/overlays/hydrography.png',
    legendsUrl: PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.HYDROGRAPHY].map(layer =>
      `https://sig.asturias.es/servicios/services/Hidrografia/MapServer/WMSServer?request=GetLegendGraphic%26version=1.3.0%26format=image/png%26layer=${layer.id}`),
    legendsWidth: PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.HYDROGRAPHY].flatMap(layer => layer.legendsWidth),
    sublayers: PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.HYDROGRAPHY].map(layer => layer.id)
  },
  {
    id: PRINCIPADO_OVERLAYS_ID.TRANSPORT_NETWORKS,
    label: 'Redes de Transporte',
    url: 'https://sig.asturias.es/servicios/services/RedesDeTransporte/MapServer/WMSServer?' +
      'service=WMS&' +
      'request=GetMap&' +
      `layers=${PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.TRANSPORT_NETWORKS].map(layer => layer.id).join(',')}&`+
      'crs=EPSG:3857&' +
      `styles=${PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.TRANSPORT_NETWORKS].map(() => 'default').join(',')}&`+
      'version=1.3.0&',
    thumbnail: '/assets/overlays/redesTransporte.png',
    legendsUrl: PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.TRANSPORT_NETWORKS].map(layer =>
      `https://sig.asturias.es/servicios/services/RedesDeTransporte/MapServer/WMSServer?request=GetLegendGraphic%26version=1.3.0%26format=image/png%26layer=${layer.id}`),
    legendsWidth: PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.TRANSPORT_NETWORKS].flatMap(layer => layer.legendsWidth),
    sublayers: PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.TRANSPORT_NETWORKS].map(layer => layer.id)
  },
  {
    id: PRINCIPADO_OVERLAYS_ID.CULTURAL_HERITAGE,
    label: 'Inventario del Patrimonio Cultural',
    url: 'https://sig.asturias.es/servicios/services/IPCA/MapServer/WMSServer?' +
      'service=WMS&' +
      'request=GetMap&' +
      `layers=${PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.CULTURAL_HERITAGE].map(layer => layer.id).join(',')}&`+
      'crs=EPSG:3857&' +
      `styles=${PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.CULTURAL_HERITAGE].map(() => 'default').join(',')}&`+
      'version=1.3.0&',
    thumbnail: '/assets/overlays/culturalHeritage.png',
    legendsUrl: PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.CULTURAL_HERITAGE].map(layer =>
      `https://sig.asturias.es/servicios/services/IPCA/MapServer/WMSServer?request=GetLegendGraphic%26version=1.3.0%26format=image/png%26layer=${layer.id}`),
    legendsWidth: PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.CULTURAL_HERITAGE].flatMap(layer => layer.legendsWidth),
    sublayers: PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.CULTURAL_HERITAGE].map(layer => layer.id)
  },
  {
    id: PRINCIPADO_OVERLAYS_ID.BUILDINGS,
    label: 'Edificaciones 1:1500',
    url: 'https://sig.asturias.es/servicios/services/Edificaciones/MapServer/WMSServer?' +
      'service=WMS&' +
      'request=GetMap&' +
      `layers=${PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.BUILDINGS].map(layer => layer.id).join(',')}&`+
      'crs=EPSG:3857&' +
      `styles=${PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.BUILDINGS].map(() => 'default').join(',')}&`+
      'version=1.3.0&',
    thumbnail: '/assets/overlays/buildings.png',
    legendsUrl: PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.BUILDINGS].map(layer =>
      `https://sig.asturias.es/servicios/services/Edificaciones/MapServer/WMSServer?request=GetLegendGraphic%26version=1.3.0%26format=image/png%26layer=${layer.id}`),
    legendsWidth: PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.BUILDINGS].flatMap(layer => layer.legendsWidth),
    sublayers: PRINCIPADO_LAYERS[PRINCIPADO_OVERLAYS_ID.BUILDINGS].map(layer => layer.id)
  },
];

export const CATASTRO_OVERLAY: Array<OverlayConfig> = [
  {
    id: CATASTRO_OVERLAY_ID.CATASTRO,
    label: 'Catastro',
    url: '',
    thumbnail: '/assets/overlays/cadastre.png',
    legendsUrl: ['https://ovc.catastro.meh.es/Cartografia/WMS/simbolos.png?'],
    legendsWidth: [200]
  }
];

export const CETEMAS_OVERLAYS = (projectName: string): Array<OverlayConfig> => [
  {
    id: CETEMAS_OVERLAYS_ID.NUCLEOS_POBLACION,
    label: 'Núcleos de Población',
    url: 'https://ide.cetemas.es/geoserver/go_velutina/wms?' +
      'service=WMS&' +
      'request=GetMap&' +
      'layers=go_velutina:Nucleos_poblacion_Asturias&'+
      'crs=EPSG:3857&' +
      'styles=&'+
      'version=1.1.0&',
    thumbnail: '/assets/overlays/nucleoPoblacion.png',
    legendsUrl: ['http://ide.cetemas.es/geoserver/go_velutina/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=go_velutina:Nucleos_poblacion_Asturias'],
    legendsWidth: [20]
  },
  {
    id: CETEMAS_OVERLAYS_ID.RED_PISTAS,
    label: 'Red de pistas',
    url: 'https://ide.cetemas.es/geoserver/reto_demografico/wms?' +
      'service=WMS&' +
      'request=GetMap&' +
      `layers=reto_demografico:${projectName}_red_pistas&`+
      'crs=EPSG:3857&' +
      'styles=&'+
      'version=1.1.0&',
    thumbnail: '/assets/overlays/redPistas.png',
    legendsUrl: [`http://ide.cetemas.es/geoserver/reto_demografico/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=reto_demografico:${projectName}_red_pistas`],
    legendsWidth: [20]
  },
  {
    id: CETEMAS_OVERLAYS_ID.CLASES_AGROECOLOGICAS,
    label: 'Clases Agroecológicas',
    url: 'https://ide.cetemas.es/geoserver/reto_demografico/wms?' +
      'service=WMS&' +
      'request=GetMap&' +
      `layers=reto_demografico:${projectName}_clases_agroecologicas&`+
      'crs=EPSG:3857&' +
      'styles=&'+
      'version=1.1.0&',
    thumbnail: '/assets/overlays/clasesAgroecologicas.png',
    legendsUrl: [`https://ide.cetemas.es/geoserver/reto_demografico/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=10&height=10&layer=reto_demografico:${projectName}_clases_agroecologicas`],
    legendsWidth: [40]
  },
  {
    id: CETEMAS_OVERLAYS_ID.MDT,
    label: 'MDT',
    url: 'https://ide.cetemas.es/geoserver/reto_demografico/wms?' +
      'service=WMS&' +
      'request=GetMap&' +
      `layers=reto_demografico:${projectName}_mdt&`+
      'crs=EPSG:3857&' +
      'styles=&'+
      'version=1.1.0&',
    thumbnail: '/assets/overlays/mdt.png',
    legendsUrl: [`https://ide.cetemas.es/geoserver/reto_demografico/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=10&height=10&layer=reto_demografico:${projectName}_mdt`],
    legendsWidth: [40]
  },
  {
    id: CETEMAS_OVERLAYS_ID.PRENDIENTE,
    label: 'Pendientes',
    url: 'https://ide.cetemas.es/geoserver/vegetacion_2cobertura/wms?' +
      'service=WMS&' +
      'request=GetMap&' +
      'layers=vegetacion_2cobertura:PTES05_ASTURIAS_Reclas&'+
      'crs=EPSG:3857&' +
      'styles=&'+
      'version=1.1.0&',
    thumbnail: '/assets/overlays/pendiente.png',
    legendsUrl: ['https://ide.cetemas.es/geoserver/vegetacion_2cobertura/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=10&height=10&layer=vegetacion_2cobertura:PTES05_ASTURIAS_Reclas'],
    legendsWidth: [250]
  },
  {
    id: CETEMAS_OVERLAYS_ID.ORIENTACION,
    label: 'Orientaciones',
    url: 'https://ide.cetemas.es/geoserver/vegetacion_2cobertura/wms?' +
      'service=WMS&' +
      'request=GetMap&' +
      'layers=vegetacion_2cobertura:ORIENT05_ASTURIAS_reclas&'+
      'crs=EPSG:3857&' +
      'styles=&'+
      'version=1.1.0&',
    thumbnail: '/assets/overlays/orientacion.png',
    legendsUrl: ['https://ide.cetemas.es/geoserver/vegetacion_2cobertura/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=10&height=10&layer=vegetacion_2cobertura:ORIENT05_ASTURIAS_reclas'],
    legendsWidth: [30]
  },
  {
    id: CETEMAS_OVERLAYS_ID.COBERTURA_BYN,
    label: 'Cobertura byn (vuelo americano)',
    url: 'https://ide.cetemas.es/geoserver/reto_demografico/wms?' +
      'service=WMS&' +
      'request=GetMap&' +
      `layers=reto_demografico:${projectName}_cobertura_byn&`+
      'crs=EPSG:3857&' +
      'styles=&'+
      'version=1.1.0&',
    thumbnail: '/assets/overlays/coberturaByn.png',
    legendsUrl: [`https://ide.cetemas.es/geoserver/reto_demografico/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=10&height=10&layer=reto_demografico:${projectName}_cobertura_byn`],
    legendsWidth: [65]
  },
  {
    id: CETEMAS_OVERLAYS_ID.COBERTURA_PNOA,
    label: 'Cobertura PNOA',
    url: 'https://ide.cetemas.es/geoserver/reto_demografico/wms?' +
      'service=WMS&' +
      'request=GetMap&' +
      `layers=reto_demografico:${projectName}_cobertura_pnoa&`+
      'crs=EPSG:3857&' +
      'styles=&'+
      'version=1.1.0&',
    thumbnail: '/assets/overlays/coberturaPnoa.png',
    legendsUrl: [`https://ide.cetemas.es/geoserver/reto_demografico/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=10&height=10&layer=reto_demografico:${projectName}_cobertura_pnoa`],
    legendsWidth: [65]
  },
  {
    id: CETEMAS_OVERLAYS_ID.PRESENCIA_CAMBIO,
    label: 'Presencia de Cambio',
    url: 'https://ide.cetemas.es/geoserver/reto_demografico/wms?' +
      'service=WMS&' +
      'request=GetMap&' +
      `layers=reto_demografico:${projectName}_presencia_cambio&`+
      'crs=EPSG:3857&' +
      'styles=&'+
      'version=1.1.0&',
    thumbnail: '/assets/overlays/presenciaCambio.png',
    legendsUrl: [`https://ide.cetemas.es/geoserver/reto_demografico/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=10&height=10&layer=reto_demografico:${projectName}_presencia_cambio`],
    legendsWidth: [90]
  },
  {
    id: CETEMAS_OVERLAYS_ID.TIPO_CAMBIO,
    label: 'Tipo de Cambio',
    url: 'https://ide.cetemas.es/geoserver/reto_demografico/wms?' +
      'service=WMS&' +
      'request=GetMap&' +
      `layers=reto_demografico:${projectName}_tipo_cambio&`+
      'crs=EPSG:3857&' +
      'styles=&'+
      'version=1.1.0&',
    thumbnail: '/assets/overlays/tipoCambio.png',
    legendsUrl: [`https://ide.cetemas.es/geoserver/reto_demografico/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=10&height=10&layer=reto_demografico:${projectName}_tipo_cambio`],
    legendsWidth: [180]
  },
  {
    id: CETEMAS_OVERLAYS_ID.MDC,
    label: 'MDC',
    url: 'https://ide.cetemas.es/geoserver/reto_demografico/wms?' +
      'service=WMS&' +
      'request=GetMap&' +
      `layers=reto_demografico:${projectName}_mdc&`+
      'crs=EPSG:3857&' +
      'styles=&'+
      'version=1.1.0&',
    thumbnail: '/assets/overlays/mdc.png',
    legendsUrl: [`https://ide.cetemas.es/geoserver/reto_demografico/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=10&height=10&layer=reto_demografico:${projectName}_mdc`],
    legendsWidth: [60]
  },
  {
    id: CETEMAS_OVERLAYS_ID.FCC,
    label: 'FCC Vegetación',
    url: 'https://ide.cetemas.es/geoserver/vegetacion_2cobertura/wms?' +
      'service=WMS&' +
      'request=GetMap&' +
      'layers=vegetacion_2cobertura:FCC_2cobertura_visor&'+
      'crs=EPSG:3857&' +
      'styles=&'+
      'version=1.1.0&',
    thumbnail: '/assets/overlays/fcc.png',
    legendsUrl: ['https://ide.cetemas.es/geoserver/vegetacion_2cobertura/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=10&height=10&layer=vegetacion_2cobertura:FCC_2cobertura_visor'],
    legendsWidth: [60]
  },
  {
    id: CETEMAS_OVERLAYS_ID.NUMERO_ESTRATOS,
    label: 'Número de estratos',
    url: 'https://ide.cetemas.es/geoserver/reto_demografico/wms?' +
      'service=WMS&' +
      'request=GetMap&' +
      `layers=reto_demografico:${projectName}_nestratos&`+
      'crs=EPSG:3857&' +
      'styles=&'+
      'version=1.1.0&',
    thumbnail: '/assets/overlays/numeroEstratos.png',
    legendsUrl: [`https://ide.cetemas.es/geoserver/reto_demografico/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=10&height=10&layer=reto_demografico:${projectName}_nestratos`],
    legendsWidth: [23]
  },
  {
    id: CETEMAS_OVERLAYS_ID.CONTINUIDAD_VERTICAL,
    label: 'Continuidad vertical',
    url: 'https://ide.cetemas.es/geoserver/reto_demografico/wms?' +
      'service=WMS&' +
      'request=GetMap&' +
      `layers=reto_demografico:${projectName}_continuidad_vertical&`+
      'crs=EPSG:3857&' +
      'styles=&'+
      'version=1.1.0&',
    thumbnail: '/assets/overlays/continuidad.png',
    legendsUrl: [`https://ide.cetemas.es/geoserver/reto_demografico/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=10&height=10&layer=reto_demografico:${projectName}_continuidad_vertical`],
    legendsWidth: [30]
  },
  {
    id: CETEMAS_OVERLAYS_ID.INDICIO_FALTA_GESTION,
    label: 'Indicio Falta de Gestión',
    url: 'https://ide.cetemas.es/geoserver/reto_demografico/wms?' +
      'service=WMS&' +
      'request=GetMap&' +
      `layers=reto_demografico:${projectName}_ifg&`+
      'crs=EPSG:3857&' +
      'styles=&'+
      'version=1.1.0&',
    thumbnail: '/assets/overlays/ifg.png',
    legendsUrl: [`https://ide.cetemas.es/geoserver/reto_demografico/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=10&height=10&layer=reto_demografico:${projectName}_ifg`],
    legendsWidth: [80]
  },
  {
    id: CETEMAS_OVERLAYS_ID.ELEMENTOS_VERTICALES,
    label: 'Elementos verticales',
    url: 'https://ide.cetemas.es/geoserver/reto_demografico/wms?' +
      'service=WMS&' +
      'request=GetMap&' +
      `layers=reto_demografico:${projectName}_pnoa_elementosverticales&`+
      'crs=EPSG:3857&' +
      'styles=&'+
      'version=1.1.0&',
    thumbnail: '/assets/overlays/elementosVerticales.png',
    legendsUrl: [`https://ide.cetemas.es/geoserver/reto_demografico/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=10&height=10&layer=reto_demografico:${projectName}_pnoa_elementosverticales`],
    legendsWidth: [20]
  },
  {
    id: CETEMAS_OVERLAYS_ID.MONTES_MANO_COMUN,
    label: 'Montes Vecinales en Mano Común',
    url: 'https://ide.cetemas.es/geoserver/reto_demografico/wms?' +
      'service=WMS&' +
      'request=GetMap&' +
      'layers=reto_demografico:Montes_Vecinales_en_Mano_Común_2024&'+
      'crs=EPSG:3857&' +
      'styles=&'+
      'version=1.1.0&',
    thumbnail: '/assets/overlays/montesManoComun.png',
    legendsUrl: ['https://ide.cetemas.es/geoserver/reto_demografico/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=10&height=10&layer=reto_demografico:Montes_Vecinales_en_Mano_Común_2024'],
    legendsWidth: [240]
  },
  {
    id: CETEMAS_OVERLAYS_ID.MONTES_COVENIO,
    label: 'Montes con Convenio o Consorcio',
    url: 'https://ide.cetemas.es/geoserver/reto_demografico/wms?' +
      'service=WMS&' +
      'request=GetMap&' +
      'layers=reto_demografico:Montes_con_Convenio_o_Consorcio_2024&'+
      'crs=EPSG:3857&' +
      'styles=&'+
      'version=1.1.0&',
    thumbnail: '/assets/overlays/montesConvenio.png',
    legendsUrl: ['https://ide.cetemas.es/geoserver/reto_demografico/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=10&height=10&layer=reto_demografico:Montes_con_Convenio_o_Consorcio_2024'],
    legendsWidth: [240]
  },
  {
    id: CETEMAS_OVERLAYS_ID.MONTES_UP,
    label: 'Montes de Utilidad Pública',
    url: 'https://ide.cetemas.es/geoserver/reto_demografico/wms?' +
      'service=WMS&' +
      'request=GetMap&' +
      'layers=reto_demografico:Montes_de_U__P_2024&'+
      'crs=EPSG:3857&' +
      'styles=&'+
      'version=1.1.0&',
    thumbnail: '/assets/overlays/montesUp.png',
    legendsUrl: ['https://ide.cetemas.es/geoserver/reto_demografico/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=10&height=10&layer=reto_demografico:Montes_de_U__P_2024'],
    legendsWidth: [200]
  },
];

export const PROJECT_OVERLAYS_ID = {
  DISPUTES: 'disputes',
  PARCEL_FILL: 'parcelFill',
};

export const PROJECT_OVERLAY = [
  {
    label: 'Alegaciones',
    thumbnail: '/assets/overlays/disputes.png',
    id: PROJECT_OVERLAYS_ID.DISPUTES
  },
  {
    label: 'Relleno de Parcelas',
    thumbnail: '/assets/overlays/parcelFill.png',
    id: PROJECT_OVERLAYS_ID.PARCEL_FILL
  }
];